const ErrorIcon = ({ className = 'h-6 w-6' }) => (
  <svg
    className={className}
    width='24'
    height='25'
    viewBox='0 0 24 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1012_29)'>
      <path
        d='M5.61095 2.4403C7.50191 1.17679 9.72505 0.50234 11.9993 0.502197C15.0467 0.511239 17.9667 1.72582 20.1215 3.88067C22.2764 6.03554 23.491 8.95557 23.5 12.003C23.4998 14.2772 22.8254 16.5003 21.5619 18.3913C20.2983 20.2824 18.5022 21.7564 16.4009 22.6268C14.2995 23.4972 11.9872 23.725 9.75647 23.2812C7.52569 22.8375 5.47658 21.7422 3.86828 20.1339C2.25997 18.5256 1.1647 16.4765 0.720975 14.2457C0.277245 12.015 0.504983 9.70269 1.37539 7.60134C2.2458 5.49999 3.71978 3.70393 5.61095 2.4403Z'
        fill='#FEE0D9'
        stroke='#F96440'
      />
      <path
        d='M16 8.0022L8 16.0022'
        stroke='#F96440'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M16 16.0022L8 8.0022'
        stroke='#F96440'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </g>
    <defs>
      <clipPath id='clip0_1012_29'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='translate(0 0.00219727)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default ErrorIcon
